import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import externalEndpoints from '@constants/configs/externalEndpoints';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { SsapData } from '../../../SsapTypes';

interface IClaimNoticeAttestation {
    actions: {
        onFieldChange_data: Function
    },
    data: SsapData,
    formName: string
}


const ClaimNoticeAttestation = (props: IClaimNoticeAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            claimNoticeDMAHSAcknowledgment
        },
        formName
    } = props;

    return (
        <UniversalInput
            label = { {
                text: 'common.input.label.non_internationalized_text',
                labelTextReplacements: {
                    text: (
                        <span className = 'required-true' >
                            <FormattedMessage
                                id = 'ssap.sign_and_review.claim_notice'
                                values = { {
                                    link: (
                                        <a
                                            className = 'usa-link--external'
                                            href = { externalEndpoints.NJ_LINKS.ESTATE_RECOVERY }
                                            target = '_blank'
                                            rel = 'noopener noreferrer'
                                        >
                                            <FormattedMessage id = 'ssap.sign_and_review.estate_recovery_link' />
                                        </a>
                                    )
                                } }
                            />
                        </span>
                    )
                }
            } }
            inputData = { {
                isInputRequired: true,
                classes: [ 'disp-styl' ],
                type: INPUT_TYPES.CHECKBOX,
                name: 'claimNoticeDMAHSAcknowledgment',
                checked: claimNoticeDMAHSAcknowledgment,
                value: claimNoticeDMAHSAcknowledgment,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: [ ]
            }}
            errorClasses = { [ 'margin-l-0' ] }
            inputActions = { {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};

export default ClaimNoticeAttestation;